import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'bom-default-contact',
  templateUrl: './default-contact.component.html',
  styleUrls: ['./default-contact.component.scss'],
})
export class DefaultContactComponent implements OnInit {
  @Input()
  title = 'Kontakt';

  isMyndighedKontaktModalOpen$: BehaviorSubject<boolean>;

  constructor() {}

  ngOnInit() {
    this.isMyndighedKontaktModalOpen$ = new BehaviorSubject<boolean>(false);
  }
}
